module.exports = __webpack_public_path__ + "static/media/left-angle.ee216d08.svg";